<script setup lang="ts">
import type { FormKitFrameworkContext } from "@formkit/core";
import type { PropType } from "vue";

import { DATA_TEST_IDS } from "@/constants/data-test-ids";
import { useFormkitComputedValue } from "@/hooks/common/use-formkit.ts";

// @deprecated (uses Formkit)
import Dropdown from "primevue/dropdown";

export interface FormKitDropdownProps {
  placeholder?: string;
  optionLabel?: string;
  options: any[];
  disabled?: boolean;
}

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext & FormKitDropdownProps>,
  },
});

const value = useFormkitComputedValue(props.context);
</script>

<template>
  <Dropdown
    v-bind="$attrs"
    :id="props.context?.id"
    v-model="value"
    :options="props.context?.options"
    :option-label="props.context?.optionLabel"
    :placeholder="props.context?.placeholder"
    :disabled="props.context?.disabled"
    class="w-full"
    :class="[props.context?.class]"
    :data-test-id="DATA_TEST_IDS.components.uiDropdown.component"
  />
</template>

<style scoped></style>
